import AdminStatisticsUsers from "../../components/admin/AdminStatisticsUsers";

export default {
  mixins: [AdminStatisticsUsers],
};
